import Vue from 'vue';
/* @vue/component */

export default Vue.extend({
  name: 'returnable',
  props: {
    returnValue: null
  },
  data: () => ({
    isActive: false,
    originalValue: null
  }),
  watch: {
    isActive(val) {
      if (val) {
        this.originalValue = this.returnValue;
      } else {
        this.$emit('update:return-value', this.originalValue);
      }
    }

  },
  methods: {
    save(value) {
      this.originalValue = value;
      setTimeout(() => {
        this.isActive = false;
      });
    }

  }
});
//# sourceMappingURL=index.js.map


// WEBPACK FOOTER //
// ./node_modules/vuetify/lib/mixins/returnable/index.js